import { EnvironmentProviders, inject, makeEnvironmentProviders } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { provideAdminSectionEntry } from '@brighthub/admin-contract';
import { provideDashboardWidget } from '@brightnav/dashboard';
import { FeatureFlagKey, FeatureFlagsService } from '@brighthub/feature-flags';
import { ReviewDashboardWidgetComponent } from './lib/components/review-dashboard-widget/review-dashboard-widget.component';

function isFlagOn(value: unknown): boolean {
  return value !== false && value !== null && value !== undefined;
}

export * from './lib/models/activity.model';
export * from './lib/services/activity-inbox.service';
export * from './lib/components/review-queue/review-queue.component';
export * from './lib/components/rtl-policy-admin/rtl-policy-admin.component';
export * from './lib/components/review-dashboard-widget/review-dashboard-widget.component';

/**
 * Registers the Review Tab Policy card on the BrightNav admin dashboard and the
 * Home AI Review widget (shown only while `enableAiReview` is on). Call from the
 * root application config, next to `provideCopilot()`.
 */
export function provideReviewTab(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAdminSectionEntry({
      id: 'rtlReviewPolicy',
      title: 'Review Tab Policy',
      description:
        'Edit RTL action-type dispositions and tooltip copy used by the Review tab (ai-activity-inbox-api policy).',
      order: 20,
      routerLink: ['review'],
    }),
    provideDashboardWidget(() => {
      const enabled = toSignal(
        inject(FeatureFlagsService)
          .getValueChanges$(FeatureFlagKey.ENABLEAIREVIEW, false)
          .pipe(map((value) => isFlagOn(value))),
        { initialValue: false },
      );
      return {
        id: 'aiReview',
        order: 30,
        component: ReviewDashboardWidgetComponent,
        visible: enabled,
      };
    }),
  ]);
}

